
export type Company = {
  id:string;
  displayId:string;
  name: string;
  nameKana: string
  managerName: string;
  managerNameKana: string;
  managerEmail: string;
  usersCount :number;
  createAt: Date;
  updateAt: Date;
  eventType?: Array<string>;
  deleteFlg: boolean;
}

export const CompanyItemMaping = (data: any | undefined): Company => {
  data.createAt = new Date(data?.createAt?.seconds * 1000);
  data.updateAt = data?.updateAt !== null
    ? new Date(data?.updateAt.seconds * 1000)
    : new Date();
  return data;
}
